import { gql } from '@apollo/client';

// warehouseId 可选：传入时后端按该仓的测试属性过滤（测试仓只返回测试配置如 VLAX1/VLAX2、
// 正式仓只返回正式配置），不传则返回全部。
// **创建包牌选下一站/目的地必须传 warehouseId**，否则正式仓会选到测试分拣仓的段码；
// 包牌列表筛选等需要看全量历史数据的场景不传。
export const GET_TT_LOCATION_OPTIONS = gql`
    query GetTtLocationOptions($locationType: Int, $warehouseId: Long) {
        getTtLocationOptions(locationType: $locationType, warehouseId: $warehouseId) {
            id
            parentId
            locationType
            code
            name
            labelCode
            sortOrder
        }
    }
`;

export interface TtLocationOption {
    id: string;
    parentId: string | null;
    locationType: number;
    code: string;
    name: string;
    labelCode: string | null;
    sortOrder: number;
}

export interface GetTtLocationOptionsResponse {
    getTtLocationOptions: TtLocationOption[];
}

/** 位置类型枚举 */
export const TT_LOCATION_TYPE = {
    FROM: 1,
    TO: 2,
    NEXT_STOP: 3,
    TEMU_LARGE_BOX: 4,
    CARRIER: 5,
    /** TT业务类型（code 与后端 TtBagBizType 枚举名一致：FBT/CBT/UNLIMITED） */
    TT_BIZ_TYPE: 6
} as const;
